<div
  *appHasAccess="['RECURRING_PAYMENT_VIEW']"
  class="payment-link-list">
  <div class="page-head">
    <div class="page-head__left"></div>
    <div class="page-head__right">

      <app-filter-button
        [isEnableUpload]="permissionService.hasPermission(['RECURRING_PAYMENT_LIST'])"
        [isOpenFilter]="isOpenFilter"

        (toggleFilterEvent)="toggleFilter($event)"
        (uploadEvent)="upload()">
      </app-filter-button>
    </div>
  </div>

  <div class="payment-page__filer">
    <app-filter-block
      [additional]="filterAdditional"
      [(isOpenFilter)]="isOpenFilter">
      <app-recurring-page-filter
        [filterCurrencies]="filterCurrencies"
        [filterRecPaymentPeriodTypes]="filterRecPaymentPeriodTypes"
        [filterNotifications]="filterNotifications"
        [filterStatuses]="filterStatuses">
      </app-recurring-page-filter>
    </app-filter-block>
  </div>

  <div class="payment-link-list__body">
    <div
      #tableBlock
      (scroll)="onScroll($event)"
      class="table">
      <div class="table-head">
        <div class="table__row">
          <div
            (click)="sortColumn('IS_BLOCKED')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'IS_BLOCKED'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content"></span>
          </div>
          <div
            (click)="sortColumn('ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.ID_PAYMENT" | translate }}
            </span>
          </div>

          <div
            class="column sortable table__row-head">
            <span>
              {{ "RECURRENT_PAGE.FIRST_PAYMENT_ID" | translate }}
            </span>
          </div>

          <div
            (click)="sortColumn('PERIOD_TYPE')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'PERIOD_TYPE'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.PERIOD" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('SUM')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'SUM'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.SUM" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('CURRENCY')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'CURRENCY'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.CURRENCY" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'NAME'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.PAYMENT_NAME" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('EMAIL')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'EMAIL'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.EMAIL" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('PAY_MAX')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'PAY_MAX'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.MAX_SUM" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('DATE')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'DATE'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "RECURRENT_PAGE.NEXT_DATE" | translate }}
            </span>
          </div>
        </div>
      </div>
      <div
        #tableBody
        class="table-body">
        <div
          *ngFor="let item of recurrentPaymentList"
          (dblclick)="navigateToPayments(item)"
          class="table__row">
          <div class="column table__row-data">
            <app-switch-table-with-dialog
              *appHasAccess="['RECURRING_PAYMENT_BLOCK']"
              onName="{{ 'RECURRENT_PAGE.ACTIVATED_PAYMENT' | translate }}"
              offName="{{ 'RECURRENT_PAGE.DEACTIVATED_PAYMENT' | translate }}"
              onHeader=" {{ 'RECURRENT_PAGE.CONFIRM_DIALOG.ON_HEADER' | translate }} "
              offHeader="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.OFF_HEADER' | translate }}"
              onDescription="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.ON_DESCRIPTION' | translate }}"
              offDescription="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.OFF_DESCRIPTION' | translate }}"
              onButtonText="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.ON_BUTTON_TEXT' | translate }}"
              offButtonText="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.OFF_BUTTON_TEXT' | translate }}"
              disabledTooltip="{{ 'RECURRENT_PAGE.COMPLETE' | translate }}"
              (itemChange)="toggleActivateLink($event)"
              [isDisabled]="item.is_complete"
              [item]="{ id: item.id.toString(), state: !item.is_blocked }
              "
              >
            </app-switch-table-with-dialog>
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "RECURRENT_PAGE.ID_PAYMENT" | translate }}:</span>
            {{ item.id }}
          </div>

          <div class="column table__row-data">
            <span class="mobile">{{ "RECURRENT_PAGE.FIRST_PAYMENT_ID" | translate }}:</span>
            {{ item.payment_id }}
          </div>

          <div class="column table__row-data">
            {{ "RECURRENT_PAGE.RECURRENT_DESCRIPTION." + item.period_type | translate }}
          </div>
          <div class="column table__row-data">
            {{ item.sum }}
            <span class="mobile">{{ item.currency }}</span>
          </div>
          <div class="column table__row-data">{{ item.currency }}</div>
          <div class="column table__row-data">
            <span>
              {{ item.name }}
            </span>

            <span class="mobile">
              {{ item.sum }}
              {{ item.currency }}

              <app-switch-table-with-dialog
                *appHasAccess="['RECURRING_PAYMENT_BLOCK']"
                onName="{{ 'RECURRENT_PAGE.ACTIVATED_PAYMENT' | translate }}"
                offName="{{ 'RECURRENT_PAGE.DEACTIVATED_PAYMENT' | translate }}"
                onHeader=" {{ 'RECURRENT_PAGE.CONFIRM_DIALOG.ON_HEADER' | translate }} "
                offHeader="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.OFF_HEADER' | translate }}"
                onDescription="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.ON_DESCRIPTION' | translate }}"
                offDescription="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.OFF_DESCRIPTION' | translate }}"
                onButtonText="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.ON_BUTTON_TEXT' | translate }}"
                offButtonText="{{ 'RECURRENT_PAGE.CONFIRM_DIALOG.OFF_BUTTON_TEXT' | translate }}"
                (itemChange)="toggleActivateLink($event)"
                [item]="{ id: item.id.toString(), state: !item.is_blocked }">
              </app-switch-table-with-dialog>
            </span>
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "RECURRENT_PAGE.EMAIL" | translate }}:</span>
            {{ item.email }}
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "RECURRENT_PAGE.MAX_SUM" | translate }}:</span>
            {{ item.pay_max }}
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "RECURRENT_PAGE.NEXT_DATE" | translate }}:</span>
            {{ item.date_start }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
